<template>
    <a
        href="javascript:void(0)"
        title="Filtrar"
        class="border border-primary rounded-3xl text-primary bg-white p-2 flex items-center my-6 w-[5rem] text-right justify-between text-sm hover:bg-gray-200 hover:underline"
        v-on:click="addClass"
    >
        <Icon class="text-primary" name="Filter" />
        Filtrar
    </a>
    <div
        class="grid modal-show fixed bg-gray-600 bg-opacity-80 top-0 left-0 items-center justify-center w-screen h-screen z-20"
        :class="{ hidden: isAddClass }"
    >
        <div class="grid rounded-2xl p-4 items-center bg-white w-[20.8rem]">
            <div>
                <div class="relative">
                    <h1 class="font-bold text-primary text-center">Filtro</h1>
                    <button
                        class="absolute top-0 right-0 font-semibold text-primary"
                        v-on:click="RemoveClass"
                    >
                        x
                    </button>

                    <a
                        href="javascript:void(0) "
                        class="absolute top-0 left-0 text-blue-500 hover:underline text-xs"
                        :class="{ hidden: isAddClassVoltar }"
                        v-on:click="RemoveClassVoltar"
                    >
                        Voltar
                    </a>
                </div>

                <div :class="{ hidden: isAddClassPeriodoData }">
                    <p class="pt-3 pb-3 font-bold text-gray-500">
                        Data<span
                            v-if="this.initialData.data && this.finalData.data"
                            class="text-xs text-gray-300"
                            >{{
                                `: ${this.initialData.data} até ${this.finalData.data}`
                            }}</span
                        >
                    </p>
                    <ul class="flex flex-wrap gap-2">
                        <li v-for="(filter, key) in [7, 15, 30, 60]" :key="key">
                            <a
                                @click="setFilterValueLessDays(filter)"
                                class="border p-2 font-bold text-xs rounded table w-full text-center border-black hover:bg-gray-300 hover:border-gray-300 transition-all cursor-pointer"
                                :class="
                                    filterLessDay == filter
                                        ? 'bg-gray-300 border-gray-300'
                                        : ''
                                "
                                >{{ filter }} Dias</a
                            >
                        </li>

                        <li class="table w-40 mt-1">
                            <a
                                href="javascript:void(0)"
                                class="border p-2 font-bold text-xs rounded table w-full text-center border-black hover:bg-gray-300 hover:border-gray-300 transition-all cursor-pointer"
                                v-on:click="resetSetDate()"
                                >Selecionar Periodo</a
                            >
                        </li>
                    </ul>
                    <div
                        class="flex flex-col gap-y-6 mt-6 max-h-[50vh] overflow-y-scroll no-scroll-bar"
                    >
                        <AutocompleteRadioV2
                            :options="{ clearWhenUpdateItems: true }"
                            :items="computedContest"
                            title="Campanha"
                            placeholder="Selecione uma campanha"
                            class="max-w-[280px]"
                            v-model="formFilter.contest"
                        />
                        <AutocompleteRadioV2
                            :options="{ clearWhenUpdateItems: true }"
                            :items="computedCategories"
                            title="Categoria"
                            placeholder="Selecione uma categoria"
                            class="max-w-[280px]"
                            v-model="formFilter.category"
                        />
                        <AutocompleteRadioV2
                            :options="{ clearWhenUpdateItems: true }"
                            :items="computedSubcategories"
                            title="Subcategoria"
                            placeholder="Selecione uma subcategoria"
                            class="max-w-[280px]"
                            v-model="formFilter.subcategory"
                        />
                        <AutocompleteRadioV2
                            :items="computedChannels"
                            title="Canal"
                            placeholder="Selecione um canal"
                            class="max-w-[280px]"
                            v-model="formFilter.channel"
                        />
                        <AutocompleteRadioV2
                            :options="{ clearWhenUpdateItems: true }"
                            :items="computedSubChannels"
                            placeholder="Selecione um subcanal"
                            class="max-w-[280px]"
                            :enable="!!formFilter.channel"
                            v-model="formFilter.subchannel"
                        />
                        <AutocompleteRadioV2
                            :items="computedCustomers"
                            title="Cliente"
                            placeholder="Selecione um cliente"
                            class="max-w-[280px]"
                            v-model="formFilter.customer"
                        />
                        <StoreFilter
                            :options="{ clearWhenUpdateItems: true }"
                            :items="computedPdvs"
                            :enable="(formFilter.channel?.length > 0)"
                            :onChange="loadPdv"
                            title="Loja"
                            class="max-w-[280px]"
                            @updateValue="handleSoldUpdate($event)"
                        />
                        <SelectCheckbox
                            :options="computedRegions"
                            title="Regional"
                            placeholder="Selecione uma ou mais regiões"
                            class="max-w-[280px]"
                            v-model="formFilter.regions"
                        />
                        <SelectCheckbox
                            :options="computedSubregions"
                            title="Sub-Regional"
                            placeholder="Selecione as sub-regionais"
                            class="max-w-[280px]"
                            v-model="formFilter.subregions"
                        />
                        <AutocompleteRadioV2
                            v-if="$page.props.auth.user.participant.type == 'M'"
                            :items="computedParticipantWithNameSap"
                            title="Participante"
                            placeholder="Selecione um participante"
                            v-model="formFilter.participant"
                        />
                        <AutocompleteRadioV2
                            :options="{ clearWhenUpdateItems: true }"
                            :items="executions"
                            :enable="(formFilter.contest?.name?.length > 0)"
                            title="Tipo de Execução"
                            :placeholder="
                                formFilter.contest?.name?.length > 0
                                    ? 'Selecione um tipo de execução'
                                    : 'Selecione uma campanha primeiro'"
                            class="max-w-[280px]"
                            v-model="formFilter.execution"
                        />
                        <SelectRadio
                            :options="[
                                { id: 'A', name: 'Aprovado' },
                                { id: 'R', name: 'Não Aprovado' },
                            ]"
                            title="Status"
                            placeholder="Selecione um tipo de status"
                            class="max-w-[280px]"
                            v-model="formFilter.status"
                        />
                    </div>

                    <ul class="grid grid-cols-2 gap-7 mt-4">
                        <li>
                            <a
                                @click="clearFilter()"
                                class="cursor-pointer grid font-bold text-primary text-center p-2 border-primary border rounded-2xl mb-2 hover:bg-gray-300"
                            >
                                Limpar Filtros
                            </a>
                        </li>
                        <li>
                            <a
                                @click.prevent="sendSpecificFilter"
                                class="cursor-pointer grid font-bold text-center p-2 border-primary border rounded-2xl mb-2 bg-primary text-white hover:bg--black hover:border-black"
                            >
                                Aplicar Filtros
                            </a>
                        </li>
                    </ul>
                </div>

                <div :class="{ hidden: isAddClassVoltar }">
                    <p class="text-gray-500 font-bold mt-1">Data</p>
                    <ul class="grid gap-5 mt-1 grid-flow-col">
                        <li>
                            <label class="mb-1 mr-5 flex font-semibold">
                                De:
                            </label>
                            <input
                                @click="setInput('initialData')"
                                v-model="initialData.data"
                                @keyup="formatDate"
                                type="text"
                                placeholder="DD/MM/AAAA"
                                class="form-input border rounded-2xl w-full focus:border-primary disabled:opacity-50 bg-gray-100 border-gray-300"
                            />
                        </li>

                        <li>
                            <label class="mb-1 mr-5 flex font-semibold">
                                Até:
                            </label>
                            <input
                                @click="setInput('finalData')"
                                v-model="finalData.data"
                                @keyup="formatDate"
                                type="text"
                                placeholder="DD/MM/AAAA"
                                class="form-input border rounded-2xl w-full focus:border-primary disabled:opacity-50 bg-gray-100 border-300"
                            />
                        </li>
                    </ul>

                    <div class="calendar bg-gray-100 p-4 mt-8 rounded-2xl">
                        <div
                            class="header grid grid-cols-3 justify-items-center"
                        >
                            <button
                                @click="prev"
                                class="font-bold text-primary text-center"
                            >
                                &lt;
                            </button>
                            <span class="font-bold text-primary text-center">{{
                                title
                            }}</span>
                            <button
                                @click="next"
                                class="font-bold text-primary text-center"
                            >
                                &gt;
                            </button>
                        </div>

                        <div
                            class="week grid grid-flow-col justify-items-center pt-2 pb-2"
                        >
                            <div class="day text-xs uppercase">Dom</div>
                            <div class="day text-xs uppercase">Seg</div>
                            <div class="day text-xs uppercase">Ter</div>
                            <div class="day text-xs uppercase">Qua</div>
                            <div class="day text-xs uppercase">Qui</div>
                            <div class="day text-xs uppercase">Sex</div>
                            <div class="day text-xs uppercase">Sab</div>
                        </div>

                        <div
                            class="week grid grid-cols-auto-calendar justify-items-center h-8 items-center text-sm"
                            v-for="(week, key) in weeks"
                            :key="key"
                        >
                            <!-- :class="day == '0' ? 'hide' : ''" -->
                            <div
                                class="day selectable g cursor-pointer hover:bg-primary hover:text-white rounded-full p-2 py-1.5 min-w-[32px] text-center"
                                :class="{ hide: isZero(day) }"
                                v-for="(day, key) in week"
                                :key="key"
                                @click="setData(day, month, year, $event)"
                            >
                                {{ day }}
                            </div>
                        </div>
                    </div>

                    <div class="grid justify-items-center mt-8">
                        <a
                            @click="saveSpecificFilter()"
                            href="javascript:void(0)"
                            class="font-semibold grid p-4 leading-normal bg-primary text-white rounded-2xl"
                            >Selecionar Datas</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { Head } from "@inertiajs/inertia-vue3";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import { formatUpdatedDate, formatDate } from "@/Helpers/masks";
import ExpandableRadio from "@/Components/ExpandableRadio.vue";
import ExpandableCheckbox from "@/Components/ExpandableCheckbox.vue";
import AutocompleteNameSAP from "@/Components/AutocompleteNameSAP.vue";
import StoreFilter from "@/Components/StoreFilter.vue";
import AutocompleteRadioV2 from "@/Components/UI/Form/AutocompleteRadioV2.vue";
import SelectRadio from "@/Components/UI/Form/SelectRadio.vue";
import SelectCheckbox from "@/Components/UI/Form/SelectCheckbox.vue";

const DATE = new Date();
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
];
const daysInYearMonth = (y, m) => new Date(y, m + 1, 0).getDate();

export default {
    components: {
        Head,
        Head,
        Icon,
        Button,
        ExpandableRadio,
        ExpandableCheckbox,
        AutocompleteNameSAP,
        AutocompleteRadioV2,
        StoreFilter,
        SelectRadio,
        SelectCheckbox,
    },

    computed: {
        formFilter: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        computedRegions() {
            return this.regions.map(({ id, name }) => ({ id, name }));
        },
        computedChannels() {
            const set = new Set();

            return this.pdvs
                ?.filter((o) => {
                    if (!o.canal) return false;

                    if (set.has(o.canal)) return false;

                    set.add(o.canal);
                    return true;
                })
                .map((item) => ({
                    id: item.canal,
                    name: item.canal,
                }));
        },
        computedSubChannels() {
            const set = new Set();

            return this.pdvs
                ?.filter((pdv) => pdv.canal == this.formFilter.channel?.name)
                ?.filter((o) => {
                    if (!o.subcanal) return false;

                    if (set.has(o.subcanal)) return false;

                    set.add(o.subcanal);
                    return true;
                })
                .map((item) => ({
                    id: item.subcanal,
                    name: item.subcanal,
                }));
        },
        computedPdvs() {
            let filteredPdvs = this.pdvs;

            if (this.formFilter.channel) {
                filteredPdvs = filteredPdvs.filter((el) => el.canal == this.formFilter.channel?.name)
            }

            if(this.formFilter.subchannel) {
                filteredPdvs = filteredPdvs.filter((el) => el.subcanal == this.formFilter.subchannel?.name)
            }

            if(this.formFilter.customer?.name) {
                filteredPdvs = filteredPdvs.filter((el) => el.customer == this.formFilter.customer?.name)
            }

            filteredPdvs = filteredPdvs.map(({ id, name, codeSoldBroker, canal, subcanal, customer }) => ({
                id,
                name,
                codeSoldBroker,
                canal,
                subcanal,
                customer,
            }));

            return filteredPdvs;
        },
        computedCategories() {
            let targetCategories = [];

            if (this.formFilter.contest) {
                targetCategories = this.contestCategories;
            } else {
                targetCategories = this.categories;
            }

            targetCategories = targetCategories.map((item) => ({
                name: item.group,
            }));

            return targetCategories;
        },
        computedSubcategories() {
            let targetSubcategories = [];

            if (this.formFilter.contest) {
                targetSubcategories = this.contestSubcategories;
            } else {
                targetSubcategories = this.subcategories;
            }

            targetSubcategories = targetSubcategories.map((item) => ({
                name: item.description,
                group: item.group,
                id: item.id,
            }));

            if (this.formFilter.category) {
                return targetSubcategories?.filter(
                    (a) => a.group == this.formFilter.category.name
                );
            } else {
                return targetSubcategories;
            }
        },
        computedContest() {
            return this.contests
                .sort((a, b) => {
                    if (a.name === b.name)
                        return moment(b.startDate).isBefore(moment(a.startDate))
                            ? 1
                            : -1;
                    return a.name.localeCompare(b.name);
                })
                .map((contest) => ({
                    ...contest,
                    name: this.handleName(contest),
                    id: contest.id,
                }));
        },
        computedSubregions() {
            let arr = this.subregions?.map(({ id, name, regionId }) => ({
                id,
                name,
                regionId,
            }));

            if (this.formFilter.regions.length > 0) {
                let filtered = this.formFilter.regions.map((region) =>
                    arr.filter((subregion) => subregion.regionId == region.id)
                );
                let merged = [].concat.apply([], filtered);

                return merged;
            } else {
                return arr;
            }
        },
        computedCustomers() {
            const set = new Set();

            return this.computedPdvs
                ?.filter((o) => {
                    if (!o.customer) return false;

                    if (set.has(o.customer)) return false;

                    set.add(o.customer);
                    return true;
                })
                .map((item) => ({
                    id: item.customer,
                    name: item.customer,
                }));
        },
        computedParticipantWithNameSap() {
            return this.participants.map(el => {
                return {
                    ...el,
                    name: `${el.name} ${el.codeSap}`
                }
            })
        }
    },

    watch: {
        'formFilter.contest':{
            handler(newValue) {
                this.loadContest(newValue);
            }
        }
    },

    props: {
        contests: Object,
        pdvs: Object,
        regions: Object,
        subregions: Object,
        participants: Object,
        categories: Object,
        subcategories: Object,
        modelValue: Object,
    },

    emits: ["sendFilter", "clearFilter", "update:modelValue"],

    data() {
        return {
            currentGallery: "",
            contestCategories: [],
            contestSubcategories: [],
            executions: [],
            showModalChangePoints: false,
            title: "-",
            month: 0,
            year: 0,
            days: [],
            weeks: [],
            filterLessDay: "",
            initialData: {
                data: "",
                elSelected: "",
                formatedData: "",
            },
            finalData: {
                data: "",
                elSelected: "",
                formatedData: "",
            },
            currentInput: "",
            isAddClass: true,
            isAddClassVoltar: true,
            isAddClassPeriodoData: false,
            isAddClassPeriodoCalendar: false,
            showSelectRegions: false,
        };
    },

    mounted() {
        this.init();
    },

    methods: {
        handleSoldUpdate($event) {
            this.formFilter.pdv = $event.store;
            this.formFilter.pdvNameLike = $event.storeLike;
        },
        handleName(contest) {
            return `${contest.name} (${moment(contest.startDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()} à ${moment(contest.endDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()})`;
        },
        resetSetDate() {
            this.isAddClassPeriodoData = true;
            this.isAddClassVoltar = false;
            this.filterLessDay = "";

            if (this.initialData.elSelected) {
                this.initialData.elSelected?.classList.remove("bg-primary");
                this.initialData.elSelected?.classList.remove("text-white");
            }
            if (this.finalData.elSelected) {
                this.finalData.elSelected?.classList.remove("bg-primary");
                this.finalData.elSelected?.classList.remove("text-white");
            }

            this.initialData.data = "";
            this.initialData.elSelected = "";

            this.finalData.data = "";
            this.finalData.elSelected = "";
        },
        resetDate() {
            this.filterLessDay = "";

            if (this.initialData.elSelected) {
                this.initialData.elSelected?.classList.remove("bg-primary");
                this.initialData.elSelected?.classList.remove("text-white");
            }
            if (this.finalData.elSelected) {
                this.finalData.elSelected?.classList.remove("bg-primary");
                this.finalData.elSelected?.classList.remove("text-white");
            }

            this.initialData.data = "";
            this.initialData.elSelected = "";
            this.initialData.formatedData = "";

            this.finalData.data = "";
            this.finalData.elSelected = "";
            this.finalData.formatedData = "";
        },
        addClass: function () {
            this.isAddClass = false;
        },

        addClassVoltar: function () {
            this.isAddClassVoltar = false;
            this.isAddClassPeriodoData = true;
        },

        RemoveClassVoltar: function () {
            this.isAddClassVoltar = true;
            this.isAddClassPeriodoData = false;
        },

        RemoveClass: function () {
            this.isAddClass = true;
            this.isAddClassVoltar = true;
            this.isAddClassPeriodoData = false;
        },

        isZero(value) {
            if (value == 0) {
                return true;
            }
        },
        getData(day, month, year) {
            if (day < 10) {
                day = `0${day.toString()}`;
            }
            if (month + 1 < 10) {
                month = `0${(month + 1).toString()}`;
            } else {
                month = month + 1;
            }
            return `${day}${month}${year}`;
        },

        setInput(input) {
            this.currentInput = input;
        },

        setData(day, month, year, el) {
            let data = this.formatData(this.getData(day, month, year));

            if (this.currentInput == "initialData") {
                if (this.initialData.elSelected) {
                    this.initialData.elSelected.classList.remove("bg-primary");
                    this.initialData.elSelected.classList.remove("text-white");
                }
                this.initialData.elSelected = el.target;
                this.initialData.elSelected.classList.add("bg-primary");
                this.initialData.elSelected.classList.add("text-white");

                this.initialData.data = data;
            }
            if (this.currentInput == "finalData") {
                if (this.finalData.elSelected) {
                    this.finalData.elSelected.classList.remove("bg-primary");
                    this.initialData.elSelected.classList.remove("text-white");
                }
                this.finalData.elSelected = el.target;
                this.finalData.elSelected.classList.add("bg-primary");
                this.initialData.elSelected.classList.add("text-white");

                this.finalData.data = data;
            }
        },

        formatData(data) {
            let value = data;

            value = value.replace(/\D/g, "");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");

            value = value.replace(/(\d{2})(\d{2})$/, "$1$2");

            return value.substr(0, 10);
        },

        next() {
            this.update(new Date(this.year, this.month + 1, 1));
        },
        prev() {
            this.update(new Date(this.year, this.month - 1, 1));
        },
        daysInMonth() {
            return daysInYearMonth(this.year, this.month);
        },
        monthStartsOn() {
            return new Date(this.year, this.month, 1).getDay();
        },
        setTitle() {
            this.title = `${MONTHS[this.month]} ${this.year}`;
        },
        update(date) {
            if (date) {
                this.month = date.getMonth();
                this.year = date.getFullYear();
                this.day = date.getDate();
            }
            this.setTitle();
            this.setDays();
            this.setWeeks();
        },
        setDays() {
            let preDays =
                this.monthStartsOn() > 0
                    ? Array(this.monthStartsOn()).fill(0)
                    : [];

            const rawDaysArray = [...Array(this.daysInMonth()).keys()];

            this.days = [...preDays, ...rawDaysArray.map((item) => item + 1)];
        },
        setWeeks() {
            let n = 0;
            this.weeks = [];

            while (n < this.days.length) {
                let week = [
                    ...this.days.slice(n, (n += 7)),
                    ...Array(7).fill(0),
                ].slice(0, 7);
                this.weeks.push(week);
            }
        },
        showEvents(day) {
            alert(day);
        },
        init() {
            this.update(DATE);
        },
        formatUpdatedDate,
        formatDate,

        setFilterValueLessDays(days) {
            let dateOffset = 24 * 60 * 60 * 1000 * days;
            let dataAtual = new Date();
            this.filterLessDay = days;

            let initialDate = new Date(dataAtual.getTime() - dateOffset);

            this.initialData.data = `${initialDate.getDate()}/${
                initialDate.getMonth() + 1
            }/${initialDate.getFullYear()}`;
            this.finalData.data = `${dataAtual.getDate()}/${
                dataAtual.getMonth() + 1
            }/${dataAtual.getFullYear()}`;

            let initialDateFormated = this.formatFilterDate(initialDate);
            let finalDataFormated = this.formatFilterDate(dataAtual);

            this.initialData.formatedData = initialDateFormated;
            this.finalData.formatedData = finalDataFormated;
        },
        formatFilterDate(data) {
            let dia = data.getDate();
            let mes = data.getMonth();
            let ano = data.getFullYear();

            return `${ano}-${mes + 1}-${dia}`;
        },

        saveSpecificFilter() {
            let initialArrayData = this.initialData.data.split("/");
            let objectInitialData = new Date(
                initialArrayData[2],
                initialArrayData[1] - 1,
                initialArrayData[0]
            );

            let finalArrayData = this.finalData.data.split("/");
            let objectFinalData = new Date(
                finalArrayData[2],
                finalArrayData[1] - 1,
                finalArrayData[0]
            );

            if (
                this.checarData(objectInitialData) &&
                this.checarData(objectFinalData)
            ) {
                let initialDateFormated =
                    this.formatFilterDate(objectInitialData);
                let finalDataFormated = this.formatFilterDate(objectFinalData);

                this.initialData.formatedData = initialDateFormated;
                this.finalData.formatedData = finalDataFormated;
            } else {
                this.initialData.formatedData = undefined;
                this.finalData.formatedData = undefined;
            }
            this.isAddClassPeriodoData = false;
            this.isAddClassVoltar = true;
        },
        sendSpecificFilter() {
            this.formFilter.startDate = this.initialData?.formatedData;
            this.formFilter.endDate = this.finalData?.formatedData;

            this.$emit("sendFilter", this.formFilter);
            this.RemoveClass();
        },
        clearFilter() {
            this.$emit("clearFilter");
            this.resetDate();
        },
        checarData(data) {
            return data instanceof Date && !isNaN(data);
        },
        loadContest(contest) {
            if(!contest) return;

            axios
                .get(`/contest/${contest.id}`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    const set = new Set();

                    this.contestCategories = data?.categories.filter((o) => {
                        if (set.has(o.group)) return false;
                        set.add(o.group);
                        return true;
                    });

                    this.contestSubcategories = data?.categories;

                    this.executions = data?.executionTypes.map((item) => ({
                        name: item.description,
                        id: item.id,
                        weight: item.weight,
                    }));
                });
        },
        loadPdv(pdv) {
            axios
                .get(`/pdv/${pdv.id}/users`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    this.form.team = [];
                    this.users = data;

                    for (let i = 0; i < Object.keys(this.$refs).length; i++) {
                        if (this.$refs[`checkbox-` + i]) {
                            this.$refs[`checkbox-` + i].checked = false;
                        }
                    }
                });
        },
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
/* .no-scroll-bar::-webkit-scrollbar {
    display: none;
} */

/* Hide scrollbar for IE, Edge and Firefox */
/* .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
} */
</style>
